module.exports = {
  menu: {
    home: 'Inicio',
    game: 'Juego',
    connect_login: 'Conectar Billetera/Iniciar Sesión',
    new_game: 'Entrar al Juego',
    invite_friends: 'Invitar Amigos',
    cms_login: 'Inicio de Sesión CMS',
    register: 'Registrar',
    login: 'Iniciar Sesión',
    logout: 'Cerrar Sesión',
    login_to_play_game: 'Inicia sesión para jugar',
    select_login_method: 'Por favor selecciona método de inicio de sesión',
    select_register_method: 'Por favor selecciona método de registro',
    email: 'Correo Electrónico',
    meta_mask: 'MetaMask',
    player_login: 'Inicio de Sesión del Jugador',
    history: 'Historial',
    transaction_history: 'Historial de Transacciones',
    ranking: 'Clasificación',
    purchase: 'Recargar',
    search_game_placeholder: 'Buscar juego..',
    new_games: 'Nuevos Juegos',
    frequent: 'Juegos Frecuentes',
    faq: 'Preguntas Frecuentes',
    terms_and_conditions: 'Términos y Condiciones de Poker Win4',
    tnc: 'Términos y Condiciones',
    about_us: 'Sobre Nosotros',
    contact_us: 'Contáctanos',
    settings: 'Configuraciones',
    lucky_draw: 'Sorteo de Suerte',
    tournament: 'Torneo',
    announcement: 'Anuncio',
    no_news: 'No hay noticias',
    online: 'En Línea',
    deposit: 'Depósito',
    terms_1_title: 'Elegibilidad para Participar',
    terms_1_content:
      'Todos los jugadores deben tener al menos 18 años y registrarse y jugar en regiones permitidas por la ley.',
    terms_2_title: 'Registro de Cuenta',
    terms_2_content: 'Los jugadores deben registrarse a través del sitio web oficial.',
    terms_3_title: 'Reglas del Juego',
    terms_3_content:
      'Todos los juegos deben seguir las reglas estándar del póker, cualquier comportamiento de trampa resultará en la suspensión o cierre de la cuenta.',
    terms_4_title: 'Depósitos y Retiros',
    terms_4_content:
      'Los jugadores deben usar los métodos de pago de la plataforma para depósitos, los retiros se procesarán de acuerdo con los tiempos de procesamiento de la plataforma.',
    terms_5_title: 'Distribución de Bonos',
    terms_5_content:
      'Los bonos se distribuirán según los resultados del juego, las reglas específicas se explicarán antes de comenzar el juego.',
    terms_6_title: 'Limitación de Responsabilidad',
    terms_6_content:
      'La plataforma no es responsable por pérdidas o daños derivados del uso de cualquier servicio o producto.',
    terms_7_title: 'Protección de Privacidad',
    terms_7_content:
      'La información personal de los jugadores será confidencial, usada únicamente para la gestión de cuentas y propósitos de juego.',
    terms_8_title: 'Modificación de Términos',
    terms_8_content:
      'La plataforma se reserva el derecho de modificar los términos y condiciones en cualquier momento, las modificaciones serán notificadas a los jugadores por correo electrónico o anuncios en el sitio web.',
  },
  common: {
    theme: 'Panel de Administración de Proyectos Básicos',
    delete_record_confirm_msg: '¿Confirmar eliminación?',
    yes: 'Sí',
    no: 'No',
    true: 'Sí',
    false: 'No',
    success: 'Éxito',
    loading: 'Cargando',
    or: 'o',
    delete: 'Eliminar',
    login: 'Iniciar Sesión',
    submit: 'Enviar',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back_to_lobby: 'Volver al Lobby',
    email: 'Correo Electrónico',
    id_document: 'Documento de Identificación',
    all_in_game: 'Póker Texas All-In/Fold',
    all_in_game_omaha: 'Omaha All-In/Fold',
    regular: 'Póker Texas',
    regular_description: 'Póker Texas se juega con apuestas ilimitadas',
    short: 'Short Deck',
    short_description: 'Short Deck Póker Texas se juega con 36 cartas',
    omaha: 'Omaha',
    omaha_description: 'Los jugadores deben usar dos cartas de mano para formar su mano',
    regular_allin: 'Póker Texas All-In/Fold',
    omaha_allin: 'Omaha All-In/Fold',
    tournament: 'Torneo',
    start: 'Iniciar Mesa',
    game_demo_area: 'Área de Experiencia de Juego',
    total_win_prize: 'Premio Total Ganado',
    waiting_list_order: 'Orden de Lista de Espera',
    join_more_than_4_room_error: 'No se puede unirse a más de 4 salas',
    system_message: 'Mensaje del Sistema',
    error: 'Error',
    register: 'Registrar',
    meta_mask: 'MetaMask',
    wallet_connect: 'Conectar Billetera',
    password: 'Contraseña',
    next_step: 'Siguiente Paso',
    next: 'Siguiente',
    verify: 'Verificar',
    copy_success: 'Copiado con éxito',
    enabled: 'Habilitado',
    enable: 'Habilitar',
    disable: 'Deshabilitar',
    done: 'Hecho',
    feature_in_progress: 'La función recomendada está en desarrollo, por favor revisa más tarde.',
    no_data: 'Sin datos',
    date: 'Fecha',
    retry: 'Reintentar',
    location_restricted_title: 'Restricción de ubicación',
    location_restricted_content:
      'La región en la que se encuentra actualmente está restringida. Algunas funciones o servicios pueden no estar disponibles. Gracias por su comprensión.',
    dont_show_again: 'No mostrar de nuevo',
    edit: 'Editar',
    i_am_not_located_in_the_restricted_country: 'No estoy ubicado en el país restringido',
  },
  auth: {
    nickname: 'Apodo',
    connect_to_win_4_poker: 'Conectar a WIN 4 POKER',
    wallet_connect_need_to_connect_ur_wallet: 'La aplicación necesita conectar tu billetera',
    wallet_connect_sign_this_message:
      'Por favor regresa a tu billetera para firmar este mensaje y demostrar que eres el propietario de esta billetera para continuar. Cancelar desconectará.',
    sign_request_in_wallet: 'Firmar solicitud en la billetera',
    sign_message_success: 'Firma exitosa',
    cancel: 'Cancelar',
    sign: 'Firmar',
    confirm_password: 'Confirmar Contraseña',
    referral_code: 'Código de Referencia',
    i_have_read_the_agreement: 'He leído el acuerdo',
    should_accept_agreement: 'Por favor acepta el acuerdo',
    alphabet_validation: 'Debe contener al menos un carácter alfabético',
    numeric_validation: 'Debe contener al menos un número',
    length_validation: 'Debe tener al menos 8 caracteres, pero no más de 20',
    placeholder: {
      enter_user_name: 'Ingresa nombre de usuario',
      enter_email: 'Ingresa correo electrónico',
      enter_password: 'Ingresa contraseña',
      confirm_password: 'Confirma contraseña',
      enter_referral_code: 'Ingresa código de referencia',
    },
    error_messages: {
      nickname: 'Por favor ingresa tu apodo',
      email_invalid: 'Este correo electrónico es inválido',
      email_required: 'Por favor ingresa tu correo electrónico',
      password_required: 'Por favor ingresa tu contraseña',
      password_confirm_required: 'Por favor confirma tu contraseña',
      password_confirm_not_matched: '¡Las dos contraseñas que ingresaste no coinciden!',
      incorrect_email_or_password: 'Correo electrónico o contraseña incorrectos',
      error_occurred: 'Ocurrió un error, por favor intenta más tarde',
    },

    // login-email page
    forget_password: '¿Olvidaste tu contraseña?',

    // forgot-password page
    forgot_password_title: 'Olvidaste tu Contraseña',
    please_enter_email_registered: 'Por favor ingresa el correo electrónico registrado',

    // email-verification page
    email_verification: 'Verificación de Correo Electrónico',
    email_has_been_sent_to: 'El correo electrónico ha sido enviado a {{value}}',
    email_resend_countdown_message:
      '¿No recibiste el correo electrónico? Puedes solicitar el reenvío en <0>countdown</0> segundos',
    please_check_your_email: 'Por favor revisa tu correo electrónico',
    waiting_to_verify_email: 'Verificando tu correo electrónico',
    agree_terms_and_privacy:
      'Al continuar con este proceso, aceptas nuestros <0>Términos</0> y <1>Política de Privacidad</1>.',
    terms: 'Términos',
    privacy_policy: 'Política de Privacidad',

    // metamask-complete-registration page
    complete_metamask_registration: 'Completar Registro en MetaMask',

    // reset-password page
    reset_password: 'Restablecer Contraseña',
    you_may_now_reset_password: 'Ahora puedes restablecer la contraseña de tu cuenta.',

    register_an_account: '¿Aún no tienes una cuenta? ¡<0>Regístrate aquí</0>!',
    resend_code_message: '¿No recibiste el correo electrónico? Haz clic aquí para <0>reenviar</0>',

    // 2FA setup page
    two_fa_via_email_title: 'Autenticación de Dos Factores por Correo Electrónico',
    otp_has_been_sent_to_email:
      'El código de verificación único ha sido enviado a tu correo electrónico registrado.',
    two_factor_authentication: 'Autenticación de Dos Factores',
    scan_this_qr_code_msg:
      'Para configurar la autenticación de dos factores (2FA), escanea este código QR con una aplicación como Authy o Google Authenticator.',
    choose_scan_qr_code_msg:
      'Abre la aplicación de autenticación, haz clic en el ícono + en la esquina inferior derecha. Elige escanear el código QR.',
    choose_enter_setup_key_msg:
      'Abre la aplicación de autenticación, haz clic en el ícono + en la esquina inferior derecha. Elige ingresar la clave de configuración.',
    secret_key: 'Clave Secreta',
    enter_code_in_authenticator_app:
      'Por favor ingresa el código mostrado en la aplicación de autenticación.',
    two_fa_is_set: {
      title: '2FA Configurado',
      message: 'Has configurado 2FA, la función de retiro ahora está disponible.',
    },

    // KYC page
    complete_email_verification_to_unlock_some_function:
      'Completa la verificación de correo electrónico para desbloquear algunas funciones',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'Completa la verificación de identidad para aumentar el monto de retiro a 100,000 USDT',
    connect_wallet_to_spin: 'Conectar billetera',

    // enter code page
    link_email: 'Enlace de correo electrónico',
    unlink_email: 'Desenlace de correo electrónico',
    expires_in: 'Expira en <0>min</0>.',
    resend_code: '<0>Reenviar código</0>',
    enter_code: 'Ingresar código',
    unlink_email_confirm_msg: '¿Estás seguro de que deseas desenlazar tu correo electrónico?',
    link_success: 'Correo electrónico enlazado con éxito',
    unlink_success: 'Correo electrónico desenlazado con éxito',
  },
  slider: {
    about: 'Acerca de',
    support: 'Soporte',
  },
  game_room: {
    confirm_leave_msg: '¿Estás seguro de que deseas salir del juego?',
    join_room_error_title: 'Error al Unirse a la Sala',
    join_room_error_msg: 'No se pudo unir a la sala, por favor intenta de nuevo',
    confirm_withdraw_extra_bet_msg: '¿Estás seguro de que deseas retirar las fichas extra?',
    total_won_prize: 'Premio Total Ganado: ${{val, number}}',
    your_balance: 'Tu Saldo: ${{val, number}}',
    no_enough_balance: 'Saldo inferior a la compra mínima de fichas: ${{val, number}}',
    cash_out: 'Cobrar Fichas y Salir',
    continue_game: 'Continuar Juego',
    remark_placeholder: 'Observaciones',
    leave_seat: 'Salir de la Silla',
    sit_in: 'Volver a la Silla',
    buy_in: 'Comprar Fichas',
    buy_in_min_amount: 'Mínimo',
    buy_in_max_amount: 'Máximo',
    seconds: 'segundos',
    close_drawer: 'Cerrar',
    leave_game: 'Salir del Juego',
    back_to_lobby: 'Volver al Lobby',
    leave_table: 'Salir de la Mesa',
    you_have_copied_room_code: 'Has copiado el código de invitación de la sala: {{value}}',
    invitation_message:
      '¡Entra ahora en la sala de juego creada por {{playerName}}! Código de invitación de la sala {{roomNumber}}, ¡comencemos a jugar!',
    link_copied: 'Has copiado el enlace con éxito',
    please_wait_until_connected: 'Por favor espera hasta que se conecte',
    rejoin_room: 'Volver a la Sala',
    theme_setting: 'Configuración de Tema',
    room_code_share: 'Copiar Código de Invitación de la Sala',
    room_link_copy: 'Compartir Enlace',
    table_setting: 'Configuración de la Mesa de Juego',
    emoji_menu: 'Menú de Emojis',
    history_drawer: 'Historial de la Sala',
    deposit: 'Depósito',
    withdraw_extra_bet: 'Retirar Fichas Extra',
    add_extra_bet: 'Agregar Fichas Extra',
    unit_convert: 'Cambio de Unidad',
    silent_mode_on: 'Modo Silencioso: Activado',
    silent_mode_off: 'Modo Silencioso: Desactivado',
    raise_to: 'Subir a',
    winner: 'Ganador',
    player_status: {
      disconnected: 'Desconectado',
      sat_out: 'Sentarse Fuera',
    },
    win_percentage: 'Porcentaje de Ganancia',
    all_in: 'All-In',
    ping_popup_msg: 'Se ha detectado una señal de red inestable, intentando reconectar',
    ping_popup_title: 'Señal de Red Inestable',
    ping_popup_content: 'Intentando reconectar, puedes intentar recargar la página',
    disconnected_modal_title: 'Señal de Red Inestable',
    afk_timer_text:
      'Has sido retirado de la silla por inactividad prolongada. Si no vuelves a la mesa dentro del tiempo limitado, serás expulsado de la sala',
    regular: 'Póker Texas',
    short: 'Short Deck',
    omaha: 'Omaha',
    omaha_all_in: 'Omaha All-In/Fold',
    buyin_option: 'Opciones de Compra',
    buy_in_amount: 'Monto de Compra',
    reminder: 'Recordatorio',
    not_enough_balance_to_buy_in: 'Saldo insuficiente para comprar fichas.',
    sitting_out: 'Sentarse Fuera',
    not_leaving_temporarily: 'No salir temporalmente',
    back_to_home: 'Volver a la Página Principal',
    are_you_sure_leave_table:
      'Eres el jugador con la mayor apuesta, ¿estás seguro de que deseas salir?',
    leave_table_with_highest_bet_error:
      'Eres el jugador con la mayor apuesta, no puedes abandonar la mesa. Por favor, inténtalo más tarde.',
    loading_room_data: 'Cargando datos de la sala...',
    sit_out_tournament_warning: {
      title: 'Advertencia de sentarse fuera del torneo',
      msg: 'Actualmente estás en un torneo. Si te sientas fuera, aún tendrás que pagar por las ciegas.',
    },
  },
  player_action: {
    bet: 'Apostar',
    call: 'Igualar',
    check: 'Pasar',
    raise: 'Subir',
    fold: 'Retirarse',
    bb: 'Ciega Grande',
    sb: 'Ciega Pequeña',
    ante: 'Ante',
    all_in: 'All-In',
    insurance_cancel: 'Cancelar Seguro',
    insurance_buy: 'Confirmar Seguro',
  },
  game_demo: {
    experience_progress: 'Progreso de Código de Experiencia',
    game_experience_zone: 'Zona de Experiencia de Juego',
    action_to_redemption: 'Completa 30 juegos válidos para canjear el código de efectivo',
    remaining_game_experience_code: 'Faltan {{val, number}}',
    cash_code_exchange: 'Canje de Código de Efectivo',
    successfully_finish_30_games: 'Completado con éxito',
    congrats: '¡Felicidades!',
    successful_exchange_cash_code: 'Código de efectivo canjeado exitosamente por {{amount}}',
    how_to_redeem: 'Cómo canjear el código de experiencia por código de efectivo',
    successful_condition_of_redemption: 'Condición: Completar 30 juegos válidos',
    two_to_three_players: 'Sala de 2-3 jugadores',
    explanation_of_valid_game:
      'Alcanzar 10BB & al final mostrar cartas propias para contar como un juego válido',
    more_than_four_players: 'Sala de 4 o más jugadores',
  },
  userProfile: {
    profile_settings: 'Configuración de Perfil',
    initial_setting_title: 'Bienvenido a Win4.Poker',
    initial_setting_description:
      'Por favor, complete la configuración inicial a continuación y disfrute de nuestros juegos',
    display_name: 'Nombre de Usuario',
    profile_picture: 'Foto de Perfil',
    edit: 'Editar',
    balance: 'Saldo',
    coin: 'USD',
    demo_coin: 'Código de Experiencia de Efectivo',
    diamond: 'Diamantes',
    game_record: 'Registro de Juegos',
    ranking_list: 'Lista de Clasificación',
    game_review: 'Revisión de Juego',
    shortcut_setting: 'Configuración de Atajos',
    user_name: 'Nombre de Usuario:',
    recommend_code: 'Código de Referencia',
    upload_image_msg: 'Arrastra la imagen aquí o',
    upload_image_browser_msg: 'Navega',
    upload_image_file_size: '(Tamaño Máximo del Archivo: 68px*93px)',
    username_length_message: 'La longitud del nombre de usuario debe estar entre 3-24 caracteres',
    chinese_username_length_message:
      'La longitud del nombre de usuario con caracteres chinos debe estar entre 1-5 caracteres',
    username_char_message:
      "El nombre de usuario solo puede contener letras, números, caracteres chinos y '_', '-', '.'",
    personal_information: 'Información Personal',
    user_icon: 'Icono de Usuario:',
    save: 'Guardar',
    my_profile: 'Mi Perfil',
    my_balance: 'Mi Saldo',
    deposit_withdraw: 'Depósito/Retiro',
    my_record: 'Mi Registro',
    flow_record: 'Registro de Flujo',
    total_earnings: 'Ganancias Totales',
    country: 'País',
    disclaimer: 'Aviso Legal',
  },
  maintenance: {
    title: 'El sitio está en mantenimiento',
    content:
      'Estamos trabajando para mejorar la experiencia del usuario. Volveremos pronto. Gracias por tu paciencia.',
  },
  useSetting: {
    card_front: 'Frente de la Carta',
    card_back: 'Reverso de la Carta',
    table: 'Mesa',
    add_token_msg: '¿Necesitas ingresar más fichas?',
  },
  lucky_draw: {
    award_history: 'Historial de premios',
    lucky_draw_rules: 'Reglas',
    remaining_lucky_draw_amount: 'Giros restantes: {{value}}',
    remaining_lucky_draw_amount_loading_label: 'Giros restantes: ',
    spin_wheel_10_times: 'Gira la rueda diez veces',
    spin_wheel: 'Gira la rueda',
    participation_rate: 'Tasa de participación en el juego: {{count}}',
    coin_loss: 'Tasa de pérdida de monedas',
    congrats: '¡Felicidades!',
    you_have_won: 'Has ganado ${{prize}}',
    collect_prize: 'Recoge tu premio',
    select_category: 'Selecciona la categoría del sorteo: ',
    special_combination: 'Combinación especial: ',
    no_history: 'No se encontró historial de sorteos',
    no_data: 'No hay datos disponibles',
    spin: 'Girar',
    fortune_wheel: 'Rueda de la Fortuna',
    christmas_fortune_wheel: 'Rueda de la Fortuna Navideña',
    new_year_fortune_wheel: 'Rueda de la Fortuna de Año Nuevo',
    cny_fortune_wheel: 'Rueda de la Fortuna del Año Nuevo Chino',
    email_login: 'Iniciar sesión',
    thank_you: 'Gracias',
    miss_msg_1:
      'Gracias por participar en nuestro evento, no tienes giros restantes, puedes unirte a nuestro juego para ganar más dinero. ¡Disfruta y buena suerte!',
    play_now: 'Jugar ahora',
    win_msg: 'Has ganado <br/> <large>{{prize}}</large> <br /> y se ha guardado en tu saldo.',
    draw_again_msg:
      'Te quedan <yellow>{{numOfDraws}}</yellow> sorteos. <clickable>Haz clic para volver a sortear.</clickable>',
    diamond: '{{value}} Diamante',
    redeem_now: 'Canjear ahora',

    deposit_more_than_10: 'DEPOSITA MÁS DE $10',
    get_1_free_spin: 'OBTÉN 1 GIRO GRATIS',
    win_10_times: 'GANA 10 VECES',
  },
  combination: {
    hi_card: 'Carta Alta',
    pair: 'Par',
    one_pair: 'Un Par',
    two_pairs: 'Dos Pares',
    set: 'Trío',
    three_of_a_kind: 'Trío',
    straight: 'Escalera',
    flush: 'Color',
    fullHouse: 'Full House',
    full_house: 'Full House',
    quad: 'Póker',
    straight_flush: 'Escalera de Color',
    royal_flush: 'Escalera Real',
  },
  room_type: {
    public: 'Sala Pública',
    private: 'Sala Privada',
  },
  forgot_password: {
    reset_password: 'Restablecer Contraseña',
    password: 'Contraseña',
    confirm_password: 'Confirmar Contraseña',
    phone: 'Teléfono',
  },
  error: {
    please_confirm: 'Por favor confirma',
    password_inconsistent: 'Las contraseñas no coinciden',
    file_size_limit_error: 'El tamaño del archivo subido está limitado a {{size}}',
    please_input: 'Por favor ingresa {{field}}',
  },
  translation: {
    success: 'Éxito',
  },
  game_list: {
    table: 'Mesa',
    random_join_table: 'Unirse a Mesa Aleatoria',
    random_join: 'Unirse Aleatoriamente',
    join: 'Unirse',
    no_room_available: 'No hay salas disponibles, por favor vuelve más tarde.',
    all_game_loaded: 'Todos los juegos han sido cargados',
    join_waiting_list: 'Unirse a Lista de Espera',
    join_table: 'Unirse a Mesa',
    join_observer: 'Observar',
    game_code: 'Código de Mesa',
    game_type: 'Tipo de Juego',
    game_limit: 'Límite de Jugadores',
    game_players: 'Jugadores',
    game_unit_test: 'Prueba Unitaria',
    game_basicBet: 'Apuesta Básica',
    game_SB: 'SB',
    game_smallBlind: 'Ciega Pequeña',
    regular: 'Póker Texas',
    all_in: 'Póker Texas All-In/Fold',
    short: 'Short Deck',
    omaha: 'Omaha',
    omaha_all_in: 'Omaha All-In/Fold',
    buy_in: 'Comprar Fichas',
    tables: 'Mesas',
    notice: 'Aviso',
    time_difference_reminder:
      'Existe una diferencia inusual entre la hora de tu sistema y la hora de internet, lo que puede afectar la función de cuenta regresiva para jugadores. Para asegurar el mejor rendimiento y precisión, por favor sincroniza la hora de tu sistema lo antes posible.',
    player_category: 'Categoría de Jugadores',
    blind_category: 'Categoría de Ciegas',
    table_category: 'Categoría de Mesa',
    chips: 'Fichas',
    player: 'Jugador',
    waiting: 'Esperando',
    avg_pot: 'Pozo Promedio',
    flop_rate: 'Tasa de Flop',
    hands_per_hour: 'Manos por Hora',
    no_of_hands_played: 'Total de Manos Jugadas',
    win: 'Ganar',
    invested: 'Invertido',
    pot: 'Pozo',
    usd_balance_updated: 'Saldo en USD actualizado a ${{balance}}',
    new_room: 'Nueva Sala',
    game: 'Juego de Efectivo',
    tournament: 'Torneo',
  },
  game_review: {
    my_bets: 'Mis Apuestas',
    date_range: 'Rango de Fechas',
    select_date_range: 'Seleccionar Rango de Fechas',
    show_all_dates: 'Mostrar Todas las Fechas',
    show_selected_dates: 'Mostrar Fechas Seleccionadas',
    no_game_record: 'No hay registros de juegos',
    win_row_message: '¡GANO!',
    lose_row_message: 'Gasto',
    ante: 'Ante',
    win: 'Ganar',
    lose: 'Perder',
    main_pot: 'Pozo Principal',
    side_pot: 'Pozo Lateral {{number}}',
  },
  leader_board: {
    rank: 'Rango',
    name: 'Nombre',
    win_game: 'Victorias Acumuladas',
    score: 'Puntuación',
  },
  home: {
    dont_miss_promotion_msg: 'No te pierdas estas',
    all_promotions: 'Todas las Promociones',
    my_game: 'Mi Juego',
    all_games: 'Todos los Juegos',
    claim_first_time_reward_button: 'Conocer',
    first_time_login: 'Primera vez iniciando sesión en el juego,',
    first_time_reward_msg: 'recibirás {{val}} monedas de experiencia',
    open_table: 'Iniciar Mesa',
    open_new_room: 'Crear Nueva Sala',
    enter_room_number: 'Ingresa el Código de Sala',
    start: 'Iniciar Mesa',
    enter_code: 'Ingresa el Código de Retiro',
    confirm: 'Confirmar',
    game_selection: 'Selección de Juego',
    start_game: 'Iniciar Mesa/Unirse a Sala',
    game_record: 'Registro de Juego',
    join_private_room: 'Sala Privada',
    roomCode: 'Código de Sala',
    please_enter_a_valid_room_code: 'Por favor ingresa un código de retiro válido',
    notice: 'Aviso',
    time_difference_reminder:
      'Existe una diferencia inusual entre la hora de tu sistema y la hora de internet, lo que puede afectar la función de cuenta regresiva para jugadores. Por favor sincroniza la hora de tu sistema lo antes posible. Si ya lo has hecho, por favor recarga la página.',
    register_success: 'Registro Exitoso',
    referral_code: 'Código de Referencia',
    referral_code_placeholder: 'Ingresa código de referencia',
    display_name: 'Nombre para Mostrar',
    display_name_placeholder: 'Ingresa nombre para mostrar',
    user: 'Jugador',
    bet_amount: 'Monto de Apuesta',
    date: 'Fecha',
    multiplier: 'Multiplicador',
    payout: 'Pago',
    free_game: 'Juego Gratis',
    play_without_money: 'Jugar sin Dinero',
    private_game: 'Juego Privado',
    play_with_friends: 'Jugar con Amigos',
    regular_content: 'El póker Texas regular utiliza apuestas ilimitadas',
    all_in_content: 'Póker Texas All-In o Fold utiliza apuestas ilimitadas',
    short_content: 'Short Deck Póker Texas utiliza apuestas ilimitadas',
    omaha_content: 'Omaha con límite de bote utiliza apuestas ilimitadas',
    omaha_all_in_content: 'Omaha All-In o Fold utiliza apuestas ilimitadas',
    player_statistics: 'Estado de Jugadores',
    lucky_draw_reminder: {
      title: 'Recordatorio',
      message: 'Te quedan {{value}} giros de suerte',
      go_to_lucky_draw: 'Ir al sorteo',
      spin_now: 'Girar ahora',
    },
  },
  disclaimer: {
    title: 'Aviso Legal',
    message:
      'Si resides en las siguientes áreas restringidas, no estás autorizado para jugar en win4.poker',
    countryList:
      'Estados Unidos, Turquía, Aruba, Bonaire, Curazao, Francia, Países Bajos, Suecia, Israel, Lituania, Eslovaquia, Bélgica, Suiza, Saba, San Eustaquio, San Martín, China, Reino Unido.',
    checkbox_message:
      'Confirmo que el juego de apuestas no está prohibido por las autoridades de mi ubicación y que tengo al menos 18 años.',
    required_message: 'Por favor acepta el aviso legal',
  },
  login: {
    user_account: 'Nombre de Usuario',
    password: 'Contraseña',
    cash_web_login: 'Inicio de Sesión de Usuario de Cash Web',
    player_register: 'Registro de Jugador',
    gateway_user_name: 'Nombre de Usuario Gateway',
    cms_login: 'Inicio de Sesión CMS',
    deposit: 'Depositar',
    deposit_amount: 'Monto de Depósito',
    deposit_message: 'Se requiere ingresar el monto de depósito',
    notice: 'Aviso',
    duplicate_login: 'Se detectó un inicio de sesión desde la misma IP',
    redirecting: 'Tu página se cargará pronto, gracias por tu paciencia.',
    loading: 'Cargando recursos, por favor espera...',
  },
  verification: {
    email_verification_code: 'Código de Verificación de Correo Electrónico',
    email_not_verify_error: 'Correo electrónico no verificado',
    confirm: 'Confirmar',
    timer_count: 'Cuenta Regresiva del Temporizador',
    resend_verification_code: 'Reenviar Código de Verificación',
    send_verification_code: 'Enviar Código de Verificación',
    input_field: 'Ingresa {{field}}',
    code: 'Código',
    successful_verify: 'Verificación exitosa',
    two_factor_authentication: 'Autenticación de Dos Factores',
    verification: 'Verificación',

    // KYC page
    verify: 'Verificar',
    security: 'Seguridad',

    kyc_status: {
      failed_verify_again: 'Verificación fallida, reintentar',
      under_review: 'En revisión',
      verify_now: 'Verificar ahora',
    },

    complete_email_verification_to_unlock_some_function:
      'Completa la verificación de correo electrónico para desbloquear algunas funciones',
    complete_id_verification_to_upgrade_withdrawal_amount:
      'Completa la verificación de identidad para aumentar el monto de retiro a 100,000 USDT',
    requirement: 'Requisito',
    verify_now: 'Verificar ahora',

    verification_code: 'Código de Verificación',
    email_verification: {
      title: 'Verificación de Correo Electrónico',
      msg: 'Por favor ingresa una dirección de correo electrónico que pueda recibir el código de verificación.',
      otp_has_been_sent_to: 'El código de verificación ha sido enviado a {{value}}',
    },

    id_card: 'Identificación',
    passport: 'Pasaporte',

    identity_verification: {
      title: 'Verificación de Identidad',
      msg: 'Por favor utiliza un documento de identificación válido para la verificación de identidad.',
      issuing_country: {
        title: 'Selecciona el país emisor del documento',
        placeholder: 'Selecciona país',
      },
      document_type: {
        title: 'Selecciona el tipo de documento de identificación',
        placeholder: 'Selecciona tipo de documento de identificación',
      },
    },

    uploadDocument: {
      title: 'Subir Documento',
      make_sure_that_your: 'Asegúrate de que tu documento:',
      is_clear_and_easy_to_read: 'Sea claro y fácil de leer',
      is_unedited: 'No haya sido editado',
      the_whole_doc_must_appear_in_photo: 'Todo el documento debe aparecer en la foto',
      no_reflective_glare: 'No tenga reflejos brillantes',

      upload_image: 'Subir Foto',
      upload_image_requirement:
        'El tamaño del archivo debe ser menor a 10MB y soportar formatos jpeg o png.',
      front_side_of_id: 'Frente de la Identificación',
      back_side_of_id: 'Reverso de la Identificación',
      personal_data_page_of_passport: 'Página de Datos Personales del Pasaporte',
      document_uploaded: 'Documento subido',
      id_document_under_review_msg:
        'Tu documento de identificación está siendo revisado, puede tomar 1-2 días hábiles completar la verificación.',
    },

    disable_2fa: {
      title: 'Deshabilitar Autenticación de Dos Factores',
      description:
        'Para continuar con la operación, por favor ingresa el código de autenticación proporcionado por la aplicación de autenticación para verificar tu identidad',
      success_message: 'Has deshabilitado la autenticación de dos factores',
    },

    error_messages: {
      document_upload_required: 'Por favor sube un documento',
      selection_required: 'Por favor selecciona una opción',
    },
  },
  table_area: {
    pot: 'Pozo',
    waiting_for_other_players: 'Esperando que otros se unan...',
    waiting_for_game_start: 'Esperando que el juego comience',
    sixty_sec: '60 segundos',
    please_select_emoji_target: 'Por favor selecciona un jugador',
  },
  best_combination: {
    hi_card: 'Carta Alta ({{value}})',
    one_pair: 'Un Par ({{value}})',
    two_pairs: 'Dos Pares ({{firstPair}}, {{secondPair}})',
    set: 'Trío ({{value}})',
    straight: 'Escalera (de {{fromValue}} a {{toValue}})',
    flush: 'Color (Carta Alta {{value}})',
    fullHouse: 'Full House ({{three_cards}} y {{two_cards}})',
    quad: 'Póker ({{value}})',
    straight_flush: 'Escalera de Color (de {{fromValue}} a {{toValue}})',
    royal_flush: 'Escalera Real',
  },
  action_buttons: {
    place_bet: 'Realizar Apuesta',
    all_in: 'All-In',
    bet: 'Apostar',
    check: 'Pasar',
    call: 'Igualar',
    raise: 'Subir',
    fold: 'Retirarse',
    pot: 'Pozo',
    confirm: 'Confirmar',
    investment: 'Inversión',
    insurance: 'Seguro',
    choosing_cards: 'Seleccionando Cartas',
    outs_number: 'Número de OUTS',
    insurance_winning_rate: 'Tasa de Ganancia',
    odds: 'Probabilidades',
    premium: 'Prima de Seguro',
    payout: 'Pago',
    call_any: 'Igualar Automáticamente',
    wait_for_blinds: 'Unirse después de las ciegas',
    join_directly: 'Unirse en la Próxima Mano',
    check_or_fold: 'Pasar / Retirarse',
    confirm_to_fold: '¿Estás seguro de que deseas retirarte?',
    max: 'Máximo',
    min: 'Mínimo',
    force_insurance: 'Seguro Obligatorio',
  },
  history_drawer: {
    title: 'Historial de la Sala',
    small_blind: 'Ciega Pequeña (Ante)',
    pre_flop: 'Pre-Flop',
    flop: 'Flop',
    turn: 'Turn',
    river: 'River',
    no_data: 'No hay datos de la sala',
    hands: 'Manos',
    winner: 'Ganador',
    buy_in: 'Compra de Fichas',
    pool: 'Pozo',
    win_player: 'Jugador Ganador',
    time: 'Hora',
    main_pot: 'Pozo Principal',
    side_pot_one: 'Pozo Lateral 1',
    side_pot_two: 'Pozo Lateral 2',
    side_pot_three: 'Pozo Lateral 3',
    win: 'Ganar',
    loading: 'Cargando',
    all_record_loaded: 'Todos los registros de la sala han sido cargados',
    previous_page: 'Página Anterior',
    close: 'Cerrar',
    detail: 'Detalle',
  },
  file_upload: {
    upload: 'Subir',
  },
  user_menu: {
    two_factor: 'Autenticación de Dos Factores',
    change_password: 'Cambiar Contraseña',
    logout: 'Cerrar Sesión',
    hello_user: 'Hola',
  },
  change_password_board: {
    change_password: 'Cambiar Contraseña',
    old_password: 'Contraseña Antigua',
    new_password: 'Nueva Contraseña',
    confirm_password: 'Confirmar Contraseña',
  },
  list_page: {
    export_title: '',
    export_info: '',
    search_bar_placeholder: 'Buscar..',
    filter: 'Filtrar',
    confirm_to_export: '',
    create_board: '',
    update_board: '',
  },
  permission_assigner: {
    read: 'Leer',
    write: 'Escribir',
    none: 'Ninguno',
    banned: 'Prohibido',
  },
  phone_input: {
    invalid_country_code: 'Código de país inválido',
    invalid_phone: 'Teléfono inválido',
    phone_number: 'Número de Teléfono',
    phone_code: 'Código de Área',
  },
  room_setting_drawer: {
    create_new_room: 'Crear Nueva Sala',
    enter_room_code: 'Ingresa el Código de Sala',
    please_enter_a_valid_room_code: 'Por favor ingresa un código de retiro válido',
    please_input_room_code: 'Por favor ingresa el código de sala',
    enter_room: 'Ingresar a Sala',
    room_setting: 'Configuración de Sala',
    small_blind: 'Ciega Pequeña:',
    ante: 'Ante:',
    buy_in: 'Compra de Fichas:',
    number_of_people: 'Número de Personas:',
    action_time: 'Tiempo de Acción:',
    game_duration: 'Duración del Juego:',
    commission: 'Comisión:',
    insurance: 'Seguro:',
    location_restriction: 'Restricción de Ubicación',
    diamond_needed: 'Diamantes Necesarios:',
    diamond_owned: 'Diamantes Poseídos:',
    redeem: 'Comprar Diamantes',
    open_room: 'Crear Sala',
    maximum: 'Máximo:',
    hours: '{{value}} horas',
    minute: '{{value}} minutos',
    second: '{{value}} segundos',
    affect_diamond_needed: 'Afecta los Diamantes Necesarios',
    remaining_room_time: 'Tiempo Restante para Finalizar Sala',
    diamond_require: 'Diamantes Necesarios:',
    time_increase: 'Aumento de Tiempo:',
    recharge: 'Recargar',
    isAllIn: 'All-In',
    ipchecking: 'Restricción de IP',
    diamond_not_enough: 'Saldo de diamantes insuficiente',
  },
  gameRecharge: {
    sticker_title: 'Pegatina',
    check_for_more: 'Ver más',
    diamond_title: 'Diamantes',
    diamond_product_tag: '{{value}} Diamantes',
    buy_diamond_confirm_msg: 'Confirmación de Compra',
    buy_sticker_confirm_msg: '¿Deseas comprar esta pegatina?',
    balance_not_enough_msg: 'Tu saldo es insuficiente',
    sticker_product_tag: 'Se requieren {{value}} diamantes',
    confirm_to_buy_button: 'Confirmar',
    confirm_title: 'Confirmación de Compra',
    confirm_message:
      '¿Confirmas comprar {{diamondAmount}} diamantes por USD$ <0>{{usdAmount}}</0>?',
    redeem: 'Recargar',
    confirm: 'Confirmar',
    reminder: 'Recordatorio',
    not_enough_money: 'Lo sentimos, tu saldo es insuficiente para comprar diamantes.',
    not_enough_diamond:
      'Tu saldo de diamantes es insuficiente, por favor compra diamantes primero.',
    quanity: 'Cantidad:',
    price: 'Precio:',
    diamond: 'Diamantes',
    sticker: 'Pegatina',
    purchase_success: 'Compra exitosa',
    purchase: 'Comprar',
    diamond_balance: 'Saldo de Diamantes',
    free_sticker: 'Este es un artículo gratuito',
    amount_required: 'Se requiere ingresar una cantidad',
    valid_amount: 'Por favor ingresa una cantidad válida',
    not_enough_diamond_balance: 'Saldo de diamantes insuficiente',
  },
  transactionRecord: {
    transactionCurrencyType: {
      all: 'Todo',
      usd: 'USD',
      cash: 'Código de Experiencia de Efectivo',
      diamond: 'Diamantes',
    },
    transactionType: {
      createRoom: 'Crear Sala Privada',
      luckyDraw: 'Jugar Sorteo de Suerte',
      purchaseItem: 'Comprar Pegatina',
      purchaseDiamond: 'Comprar {{value}} Diamantes',
      joinGame: 'Participar en {{value}} Juegos',
      winGame: 'Ganar {{value}} Juegos',
      loseGame: 'Perder {{value}} Juegos',
      winGameWithoutGameType: 'Ganar Juego',
      loseGameWithoutGameType: 'Perder Juego',
      joinGameWithoutGameType: 'Participar Juego',
      deposit: 'Recargar',
      redeemDemo: 'Canjear Código de Efectivo',
      insurance: 'Seguro',
      gift: 'Regalo',
      firstLogin: 'Primer Inicio de Sesión',
      privateRoomRebate: 'Reembolso de Sala Privada',
    },
    transactionRecord: 'Detalle de Transacciones',
    no_transaction_record: 'Sin registros de transacciones',
    currentMonth: 'Este Mes',
  },
  emojiPanel: {
    buy_sticker_confirm_msg: '¿Deseas comprar esta pegatina?',
    sticker_product_tag: 'Se requieren {{value}} diamantes',
    confirm_to_buy_button: 'Confirmar Compra',
    emoji: 'Emoji',
    free: 'Gratis',
    no_available_emoji: 'No hay pegatinas disponibles',
  },
  playerInfo: {
    button: 'Botón',
    smallBlind: 'Ciega Pequeña',
    bigBlind: 'Ciega Grande',
    cutOff: 'Cutoff',
    underTheGun: 'Under the Gun',
    bet: 'Apuesta',
    check: 'Pasar',
    call: 'Igualar',
    raise: 'Subir',
    fold: 'Retirarse',
    cancelInsurance: 'Cancelar\nSeguro',
    confirmInsurance: 'Confirmar\nSeguro',
    allIn: 'All-In',
    skip: 'Saltar',
  },
  deposit_withdraw: {
    currency_usdt: 'Tether (USDT)',
    deposit_method: 'Método de depósito',
    remark: 'Observación',
    ton_connect: 'Conectar TON',
    manual_deposit: 'Depósito manual',
    usdt: 'USDT',
    eth: 'ETH',
    btc: 'BTC',
    deposit: 'Depositar',
    withdraw: 'Retirar',
    withdrawal: 'Retiro',
    history: 'Historial de Depósitos/Retiros',
    blockchain: 'Blockchain',
    currency: 'Moneda',
    network: 'Red',
    exchange_rate: 'Tipo de Cambio',
    deposit_address: 'Dirección de Depósito',
    deposit_process_message_1:
      'Una vez que el sistema reciba los fondos, el procesamiento del depósito se realizará de inmediato, el proceso tarda aproximadamente dos horas, por favor espera pacientemente.',
    back: 'Volver',
    address: 'Dirección',
    transaction_id: 'ID de Transacción',
    amount: 'Cantidad a Retirar',
    time: 'Hora',
    coin_type: 'Tipo de Moneda',
    available_amount: 'Cantidad Disponible para Retirar',
    withdraw_amount: 'Cantidad a Retirar',
    withdraw_cost: 'Costo de Retiro',
    receiving_amount: 'Cantidad Estimada a Recibir',
    deposit_amount: 'Cantidad a Depositar',
    deposit_amount_placeholder: 'Por favor ingresa la cantidad a depositar',
    no_data: 'Sin datos',
    address_placeholder: 'Por favor ingresa la dirección',
    amount_placeholder: 'Por favor ingresa la cantidad',
    withdrawal_amount: 'Cantidad a Retirar',
    withdrawal_fee: 'Comisión de Retiro',
    max: 'Máximo',
    available_cash_out_balance: 'Saldo Disponible para Retirar',
    cash_out_info:
      'Después de participar en el pozo, solo puedes retirar USDT ganados en juegos de póker, o retirar en caso de empate en el juego.',
    wallet_balance: 'Saldo de Billetera',
    deposit_pending_title: 'Depósito Pendiente',
    deposit_pending_description: 'Tu depósito está actualmente en espera de aprobación',
    deposit_success_title: 'Depósito Exitoso',
    deposit_success_description: 'Los fondos han sido acreditados a tu cuenta',
    create_withdraw_success_title: 'Solicitud de Retiro Exitosa',
    create_withdraw_success_description: 'Tu solicitud de retiro está siendo procesada',
    withdrawal_success_title: 'Retiro Exitoso',
    withdrawal_success_description: 'Tu solicitud de retiro ha sido completada',
    amount_required: 'El monto es requerido',
    amount_exceeds_available: 'La cantidad excede el saldo disponible',
    amount_below_minimum: 'La cantidad está por debajo del mínimo requerido',
    amount_below_fee: 'La cantidad está por debajo de la tarifa',
    invalid_number: 'Número inválido',
    network_required: 'Se requiere seleccionar una red',
    address_required: 'Se requiere ingresar una dirección',
    blockchain_required: 'Se requiere seleccionar una blockchain',
    email_required: 'Se requiere ingresar un correo electrónico',
    valid_amount: 'Por favor ingresa una cantidad válida',
    notice: 'Aviso',
    cancel: 'Cancelar',
    cancel_transaction: 'Has cancelado la transacción',

    from: 'De',
    receive_amount: 'Cantidad a Recibir',

    // 2FA
    two_fa_required_msg:
      'Para mayor seguridad, debes configurar la autenticación de dos factores antes de poder retirar.',
    setup_2fa: 'Configurar 2FA',
    lost_my_2fa_access: 'Perdí el acceso a 2FA',
    wallets_usdt_token: 'USDT de la billetera',
    memo_reminder_1:
      'Asegúrese de ingresar {{memo}} en la sección de comentarios, de lo contrario, nuestro sistema no podrá depositar los fondos en su cuenta.',
    memo_reminder_2: 'Si utiliza TonConnect, el sistema lo completará automáticamente.',

    wait_for_next_lucky_draw:
      'Por favor, espera el próximo sorteo de la suerte para tener la oportunidad de recibir fondos para jugar.',
  },
  history_status: {
    completed: 'Completado',
    pending: 'En Proceso',
  },
  transaction_history: {
    tab_titles: {
      all_flow: 'Todo el Flujo',
      deposits: 'Depósitos',
      withdrawals: 'Retiros',
      bets: 'Apuestas',
      purchase: 'Compra de Diamantes',
      diamond: 'Diamantes',
    },
    transaction_type: 'Tipo de Transacción',
    transaction_types: {
      deposits: 'Depósitos',
      withdrawals: 'Retiros',
      bets: 'Apuestas',
      purchase: 'Compra de Diamantes',
      diamond: 'Diamantes',
      purchase_item: 'Transacción de Diamantes',
      referral_commission: 'Comisión por Referencia',
      payout: 'Pago',
      private_room: 'Crear Sala Privada',
      private_room_rebate: 'Reembolso de Sala Privada',
      reward: 'Recompensa',
      lucky_draw: 'Sorteo de Suerte',
      tournament_prize: 'Premio de Torneo',
      tournament_ticket_fee: 'Tarifa de Entrada de Torneo',
    },
    game_type: 'Tipo de Juego',
    type: 'Tipo',
    bet: 'Apuesta',
    payout: 'Pago',
    amount: 'Cantidad',
    quantity: 'Cantidad',
    balance: 'Saldo',
    diamond: 'Diamantes',
    sticker: 'Pegatina',
  },
  referral: {
    referral: 'Referido',
    invite_friends_description: 'Invita a tus amigos a unirse a Win4Poker y obtén recompensas',
    whatsapp_referral_message:
      '¿Estás listo para ganar en grande? 🃏 ¡Únete a mí en Win4Poker y disfruta de emocionantes partidas! Este es mi enlace de invitación: ',
    number_of_referrals: 'Número de Referidos',
    referral_rewards: 'Recompensas por Referencia',
    my_commission: 'Mi Comisión',
    referral_code: 'Código de Referencia',
    referral_link: 'Enlace de Referencia',
    enter_code: 'Ingresar Código',
    terms_and_conditions: 'Términos y Condiciones de Win4Poker',
    invite_friends: 'Invitar Amigos',
    pop_up_title: 'Aviso',
    back_home: 'Volver a Inicio',
    scan_qr_code: 'Escanear Código QR',
    code: 'Código',
    copy_link: 'Copiar Enlace',
    save_image: 'Guardar Imagen',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    more: 'Más',
    referral_history: 'Historial de Referidos',
    register_time: 'Hora de Registro',
    player: 'Jugador',
    reward_time: 'Hora de Recompensa',
    reward_amount: 'Monto de Recompensa',
    referral_list: 'Lista de Referidos',
    enter: 'Ingresar',
    skip: 'Saltar',
    please_input_referral_code: 'Por favor ingresa un código de referencia',
    enter_referral_code: 'Ingresar Código de Referencia',
    enter_referral_code_success: 'Código de referencia ingresado con éxito',
    cannot_use_own_referral_code: 'No puedes usar tu propio código de referencia',
    total: 'Total',
    referral_code_invalid: 'Código de referencia inválido',
    commission: 'Comisión',
    reward_type: 'Tipo de Recompensa',
    amount: 'Monto',
    commission_reward: 'Recompensa de Comisión',
    commission_update_success: 'Actualización de comisión exitosa',
    commission_setting: 'Configuración de Comisión',
    save: 'Guardar',

    // title
    promotion_1: 'Referencia 1: Bono de Depósito',
    promotion_2: 'Referencia 2: Recompensa por Código de Referencia',
    general_terms: 'Términos y Condiciones Generales',

    commission_calculation: {
      title: 'Cálculo de Comisión',
      first_layer: '1er Nivel %',
      second_layer: '2do Nivel %',
      third_layer: '3er Nivel %',
      refers: 'Referencias',
      referrer: 'Referente',
      content:
        'El 5% de las ganancias se deducirá como comisión. La pasarela recibirá el 30% de la comisión como <0>MÁXIMO</0>. La pasarela distribuirá el 70% restante de la comisión al referente de nivel superior, quien puede decidir asignar un Z% del 70% de la comisión al siguiente nivel de referentes. El referente del siguiente nivel puede decidir distribuir un Y% del Z% de la comisión al nivel inferior, y este proceso continúa hasta que la comisión llega al referente ganador.',
      example: {
        title: 'Ejemplo:',
        winner_wins: 'Ganador Gana: ${{value}}',
        total_commission: 'Comisión Total: ${{value}}',
        gateway_total_commission_max: 'Comisión Total de Pasarela (MÁX): ${{value}}',
        referral_total_commission_min: 'Comisión Total de Referencia (MÍN): ${{value}}',

        referral_commissions: 'Comisiones de Referencia (70 ≥ Z ≥ Y ≥ X ...):',
        referrer_1_commission: 'Referente 1: ${{totalCommission}} × (Z% - Y%)',
        referrer_2_commission: 'Referente 2: ${{totalCommission}} × (Y% - X%)',
        referrer_3_commission: 'Referente 3: ${{totalCommission}} × X%',
      },
    },

    // sub-title
    eligibility: 'Elegibilidad',
    offer: 'Oferta',
    conditions: 'Condiciones',
    program_duration: 'Duración del Programa',
    account_verification: 'Verificación de Cuenta',
    limitations: 'Limitaciones',
    modification_of_terms: 'Modificación de Términos',
    compliance: 'Cumplimiento',
    support: 'Soporte',

    error_messages: {
      referral_code_invalid:
        'El código de referencia debe tener entre 4 y 8 caracteres, y solo puede contener caracteres alfanuméricos excluyendo "I" y "O"',
      referral_code_required: 'El código de referencia es obligatorio',
    },

    // points
    eligibility_1: 'Los usuarios deben depositar más de 1 USDT en su cuenta de Win4Poker.',
    offer_1:
      'Los usuarios elegibles recibirán un regalo gratuito de 1 USDT directamente en su cuenta.',
    conditions_1: 'Esta oferta no tiene restricciones.',
    conditions_2:
      'El depósito debe realizarse dentro del período de referencia especificado por Win4Poker.',
    conditions_3:
      'Los usuarios deben tener una cuenta verificada para calificar para esta referencia.',

    eligibility_2: 'Los usuarios deben usar su código de referencia único para referir amigos.',
    offer_2:
      'Cuando los amigos referidos completen su primer juego, el referente recibirá un 3.5% del total del pozo como recompensa.',
    conditions_4:
      'Los amigos referidos deben usar el código de referencia del referente al registrarse.',
    conditions_5:
      'La recompensa se otorgará dentro de las 2 horas posteriores a que el amigo referido complete su juego.',
    conditions_6:
      'Los usuarios pueden rastrear sus referencias y recompensas a través de su panel de control de cuenta.',
    program_duration_1:
      'Estas promociones se llevarán a cabo durante el período especificado comunicado en nuestro sitio web y canales oficiales.',
    account_verification_1:
      'Los participantes deben tener una cuenta completamente verificada para calificar para cualquier recompensa.',
    limitations_1:
      'Los usuarios que se descubra que abusan del sistema de referencias (por ejemplo, referirse a sí mismos) pueden tener su cuenta suspendida o deshabilitada.',
    modification_of_terms_1:
      'Win4Poker se reserva el derecho de modificar o terminar estas promociones de referencia en cualquier momento sin previo aviso.',
    compliance_1:
      'Los participantes deben cumplir con todas las leyes y regulaciones aplicables de juegos en línea y referencias en su jurisdicción.',
    support_1:
      'Para preguntas o asistencia sobre el programa de referencia, por favor contacta a nuestro equipo de soporte al cliente.',

    // disclaimer
    disclaimer: 'Aviso Legal',
    disclaimer_1:
      'Todas las recompensas están sujetas a disponibilidad y pueden variar según el estado de la cuenta y las actividades.',
    disclaimer_2:
      'Win4Poker no se responsabiliza por problemas técnicos que puedan interferir con el seguimiento exitoso de referencias o recompensas.',

    fixed_commission: 'Comisión Fija',
    custom_commission: 'Comisión Personalizada',
    invalid_commission_percentage: 'Porcentaje de comisión inválido',
    commission_placeholder: 'Ingresar porcentaje de comisión',
    my_share: 'Mi Parte',
  },
  ranking: {
    ranking: 'Clasificación',
    today: 'Hoy',
    this_week: 'Esta Semana',
    this_month: 'Este Mes',
  },
  tournament: {
    you_have_won: 'Has ganado',
    time_elapsed: 'Tiempo Transcurrido',
    prize_pool: 'Pozo de Premios',
    entries: 'Participantes',
    of: 'de',
    congratulations: 'Felicitaciones',
    thanks_for_your_joining: 'Gracias por tu participación',
    watch: 'Ver',
    see_result: 'Ver Resultado',
    view_tournament: 'Ver Torneo',
    deregister: 'Cancelar Registro',
    start_in: 'Comienza en <0>countdown</0>',
    full: 'Completo',
    register_end_in: 'Registro termina en <0>countdown</0>',
    my_ranking: 'Mi Clasificación',
    players: 'Jugadores',
    register: 'Registrarse',
    pay_for_registration: 'Pagar {{ticketFee}} para Registro',
    register_confirmation_message:
      'Para registrarse en el torneo, se cobrará una tarifa de {{ticketFee}}, ¿desea registrarse en {{tournamentName}}?',
    late_register: 'Registro Tardío',
    level: 'Nivel',
    blinds: 'Ciegas (SB/BB)',
    ante: 'Ante',
    duration: 'Duración',
    game_rule: 'Regla del Juego',
    game_mode: 'Modo de Juego',
    speed: 'Velocidad',
    general_information: 'Información General',
    ticket_fee: 'Tarifa de Entrada',
    starting_stack: 'Stack Inicial',
    blinds_start: 'Inicio de Ciegas',
    ante_starts: 'Inicio de Ante',
    raised_every: 'Aumenta Cada',
    minutes: 'minutos',
    prize: 'Premio',
    structure: 'Estructura',
    gameModeTitle: {
      classic: 'Clásico',
      turbo: 'Turbo',
      hyper: 'Hyper',
    },
    gameModeDescription: {
      classic:
        'Torneo multimesa clásico donde los participantes compiten para ganar una parte del pozo total de premios.',
    },
    speedTitle: {
      regular: 'Regular',
      turbo: 'Turbo',
      hyper: 'Hyper',
    },
    speedDescription: 'Las ciegas aumentan cada {{value}} minutos',
    tournament: 'Torneo',
    today: 'Hoy',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
    upcoming: 'Próximos',
    results: 'Resultados',
    on_going: 'En Curso',
    title: 'Detalles del Torneo',
    tables: 'Mesas',
    minutes_short: 'min',
    current_blinds: 'Ciegas Actuales',
    next_blind_at: 'Próxima Ciega En',
    start_game_in: 'Inicio del Juego En',
    no_tournaments_available: 'No hay torneos disponibles',
    you_have_not_participated_in_any_tournament_yet: 'Aún no has participado en ningún torneo',
    tournament_started: 'Torneo Iniciado',
    tournament_ended_msg: 'Torneo finalizado',
    tournament_canceled_msg: 'Torneo cancelado',
    view_table: 'Ver mesa',
    view_player_table: 'Ver mesa del jugador',
    table_rebalancing: 'Rebalanceo de Mesa',
    upcoming: 'Próximos',
    in_progress: 'En Curso',
    finished: 'Finalizados',
    waiting_enough_players_to_start: 'Esperando a que haya suficientes jugadores para comenzar',
    cancelled: 'Cancelado',
    table_rebalancing: 'Reequilibrio de mesa',
    too_many_rooms_description:
      '{{tournamentName}} comenzará pronto, pero has alcanzado la cantidad máxima de mesas, por favor, abandona al menos 1 de las siguientes mesas para unirte a {{tournamentName}}.',
    leave: 'Abandonar',
    sit_in: 'Sentarse en {{name}}',
    ignore: 'Ignorar',

    re_entry_modal: {
      title: '¿Volver a entrar al Torneo?',
      description:
        '{{tournamentName}} aún está abierto para unirse, ¿quieres gastar ${{ticketFee}} de tarifa de entrada para volver a unirte al torneo?',
      re_enter: 'Volver a entrar',
      view_tournament: 'Ver Torneo',
    },
    waiting_for_players: {
      title: 'Esperando jugadores',
      message: 'Esperando a {{count}} jugador más para unirse',
      message_plural: 'Esperando a {{count}} jugadores más para unirse',
    },
    thanks_for_joining: {
      title: '¡Gracias por unirte!',
      description: 'Gracias por unirte a {{tournamentName}}. El torneo aún está en curso, puedes ver tu resultado más tarde.',
      view_results: 'Ver resultados del torneo',
    },
    cancel: {
      title: 'Torneo cancelado',
      description: 'El torneo "{{tournamentName}}" ha sido cancelado.',
      refund_message: 'Tu tarifa de entrada de ${{amount}} será reembolsada.',
      confirm: 'OK',
    },
    waiting_timer: {
      title: 'Esperando jugadores',
      cancel_in: 'Cancelar en',
    },
  },
  errorCodes: {
    default: {
      title: 'Error del sistema',
      message: 'Algo salió mal, por favor inténtalo de nuevo más tarde',
    },

    WS_0000: 'Error del Sistema',
    WS_0001: 'No se puede entrar a más de 4 salas',
    WS_0002: 'No se puede salir durante la apuesta más alta',
    WS_0003: 'Error de verificación, por favor recarga la página e intenta de nuevo',
    WS_0004:
      'Se detectaron personas cercanas en la sala, por lo tanto no se puede entrar temporalmente',
    WS_0005:
      'No puedes salir siendo el jugador con la apuesta más alta. Por favor, retírate primero',
    WS_0006: 'Error al comprar fichas',
    WS_0007: 'Sala de juego no encontrada',

    HP_0001: 'No se puede entrar a más de 4 salas',
    HP_0002: 'Actualmente no se puede conectar al servidor, por favor intenta más tarde.',
    HP_0003: 'Monto de compra insuficiente',
    HP_0004: 'Código de verificación no válido',
    INVALID_EMAIL_PASS_CODE: 'Código de verificación no válido',
    INVALID_OTP: 'Código de verificación inválido',
    INVALID_REFERRAL_CODE: 'Código de referencia no válido',
    REFERRAL_CODE_ALREADY_USED: 'El código de referencia ya ha sido utilizado',
    INSUFFICIENT_COINS: 'Saldo de billetera insuficiente',
    JOIN_TOURNAMENT_ERROR: 'Error al unirse al torneo',
    LOCATION_CHECKING_FAILED: {
      PERMISSION_DENIED: 'Se denegó el acceso a la ubicación.',
      POSITION_UNAVAILABLE:
        'La información de ubicación no está disponible. Por favor, inténtelo de nuevo más tarde.',
      TIMEOUT: 'La solicitud para obtener su ubicación ha expirado. Por favor, inténtelo de nuevo.',
      UNKNOWN: 'Se produjo un error desconocido al solicitar su ubicación.',
    },
    TOURNAMENT_IS_FINISHED: 'El torneo ha finalizado',
    GPS_RESTRICTION:
      'No se puede detectar la ubicación o un jugador cercano se ha unido a la misma sala, inténtalo de nuevo más tarde',
  },
};
